import React from 'react';
import { WbGrid, WbHeading, WbIcon, WbLink, WbText } from '@workbench/react';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../common/i18n/useTranslation';

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        display: 'grid',
        gap: theme.spacing(4),
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
}));

function AdminMissingPermission() {
    const translate = useTranslation();
    const { classes } = useStyles();
    const navigate = useNavigate();

    return (
        <WbGrid className={classes.container}>
            <WbHeading size="l">{translate('access_denied_title')}</WbHeading>
            <WbText size="m">{translate('access_denied_info')}</WbText>
            <WbText size="m">
                <WbLink variant="standalone" theme="light" onClick={() => navigate('/')}>
                    <WbIcon name="bds/chevron-left/24" />
                    {translate('back_to_homepage')}
                </WbLink>
            </WbText>
        </WbGrid>
    );
}

export default React.memo(AdminMissingPermission);
